// Terms & Conditions content, mirrored from https://www.phyber.care/legal/terms
import { COLOR_HEADING, h, p, ul, link, mail } from "./privacyPolicy";

export const termsOfServiceHtml = [
  `<h2 style="font-size:20px;font-weight:700;color:${COLOR_HEADING};margin:0 0 4px;">Terms &amp; Conditions</h2>`,
  p("These Terms govern your access to and use of the Phyber platform, services, applications, and digital healthcare infrastructure."),
  `<p style="font-size:13px;color:#64748B;margin:0 0 16px;">Effective Date: 15 January 2025</p>`,
  p("Welcome to Phyber Platform. By accessing or using the Phyber mobile application, website, or any related services, you agree to be bound by these Terms &amp; Conditions. If you do not agree with these Terms, please do not use the Platform."),

  h("1. About Phyber"),
  p("Phyber (a product of Northoak Technologies Private Limited) is a digital healthcare and employee/student wellbeing platform that enables users to access healthcare-related services, including but not limited to:"),
  ul([
    "OPD benefit management",
    "Teleconsultations (where available)",
    "Mental wellness services",
    "Health and wellbeing content",
    "Appointment booking",
    "Diagnostic and pharmacy partner services",
    "Digital health records and related healthcare services",
  ]),
  p("Phyber acts as a technology platform facilitating access to healthcare services provided by independent healthcare professionals and partner organizations."),

  h("2. Eligibility"),
  p("You must be at least 18 years of age to register and use the Platform independently."),
  p("Users below 18 years may use the Platform only under the supervision and consent of a parent, guardian, institution, or authorized representative."),

  h("3. User Registration"),
  p("You agree to:"),
  ul([
    "Provide accurate and complete information.",
    "Maintain the confidentiality of your account credentials.",
    "Notify Phyber immediately of any unauthorized access to your account.",
  ]),
  p("You are responsible for all activities conducted through your account."),

  h("4. Healthcare Services"),
  p("Healthcare services available through the Platform are provided by independent healthcare professionals, hospitals, clinics, laboratories, counsellors, and other healthcare partners."),
  p("Phyber:"),
  ul([
    "Does not practice medicine.",
    "Does not provide medical diagnosis or treatment.",
    "Does not guarantee any specific health outcome.",
    "Does not endorse any specific healthcare provider.",
  ]),
  p("Medical decisions remain solely between the user and the healthcare professional."),

  h("5. Teleconsultations"),
  p("Where teleconsultation services are offered:"),
  ul([
    "User consent is deemed to be provided upon initiating a consultation.",
    "Users acknowledge the limitations of remote consultations.",
    "Healthcare professionals may recommend an in-person consultation where clinically necessary.",
    "Emergency medical conditions should not be managed solely through the Platform.",
  ]),
  p("In case of a medical emergency, users should immediately contact emergency services or visit the nearest healthcare facility."),

  h("6. OPD Benefits and Wallets"),
  p("Where applicable, users may receive healthcare benefits sponsored by employers, educational institutions, insurers, or other organizations."),
  ul([
    "Are subject to eligibility criteria.",
    "May have spending limits, validity periods, exclusions, and restrictions.",
    "May be modified or withdrawn by the sponsoring organization.",
  ]),
  p("Phyber is not responsible for benefit decisions made by sponsoring organizations."),

  h("7. Payments"),
  p("Users agree to pay applicable charges for services availed through the Platform."),
  p("Payments may be processed through third-party payment providers."),
  p("Refunds, cancellations, and rescheduling shall be governed by the applicable service-specific policies."),

  h("8. Health Information and Consent"),
  p("By using the Platform, you consent to the collection, processing, storage, and sharing of your information as necessary for providing services."),
  p("You confirm that:"),
  ul([
    "Information provided by you is accurate.",
    "You are authorized to provide information relating to any dependent or family member whose profile you manage.",
    "You consent to electronic communication regarding your healthcare services.",
  ]),

  h("9. Privacy and Data Security"),
  p("Phyber takes reasonable measures to safeguard personal and health information."),
  p("However, no electronic system can guarantee complete security, and users acknowledge the inherent risks associated with internet-based services."),
  p("Use of the Platform is also governed by Phyber's Privacy Policy."),

  h("10. Intellectual Property"),
  p("All content, software, trademarks, logos, graphics, and materials available on the Platform are the property of Phyber or its licensors. Users may not copy, modify, distribute, or commercially exploit any content without prior written permission."),

  h("11. Prohibited Activities"),
  p("Users shall not:"),
  ul([
    "Provide false or misleading information.",
    "Attempt unauthorized access to the Platform.",
    "Upload harmful software or malicious content.",
    "Misuse healthcare services.",
    "Violate any applicable law or regulation.",
  ]),
  p("Phyber reserves the right to suspend or terminate accounts that violate these Terms."),

  h("12. Limitation of Liability"),
  ul([
    "Phyber shall not be liable for medical decisions, treatment outcomes, or professional advice provided by healthcare providers.",
    "Phyber shall not be responsible for interruptions, delays, technical failures, or third-party service disruptions.",
    "Phyber's total liability shall not exceed the amount paid by the user for the relevant service during the preceding twelve months.",
  ]),

  h("13. Indemnity"),
  p("You agree to indemnify and hold harmless Phyber, its directors, employees, affiliates, and partners from any claims, losses, liabilities, or expenses arising from:"),
  ul([
    "Your use of the Platform.",
    "Violation of these Terms.",
    "Misuse of healthcare services.",
  ]),

  h("14. Modification of Services"),
  p("Phyber may modify, suspend, or discontinue any service at any time without prior notice."),

  h("15. Termination"),
  p("Phyber may suspend or terminate user access if:"),
  ul([
    "These Terms are violated.",
    "Fraudulent or unlawful activity is detected.",
    "Continued access poses risk to users or the Platform.",
  ]),

  h("16. Governing Law and Jurisdiction"),
  p("These Terms shall be governed by the laws of India. Any dispute arising out of or relating to these Terms shall be subject to the exclusive jurisdiction of the courts located in Bengaluru, Karnataka."),

  h("17. Contact Us"),
  p("<strong>Northoak Technologies Private Limited</strong>"),
  p(`Email: ${mail("support@phyber.care")}`),
  p(`Website: ${link("https://www.phyber.care", "www.phyber.care")}`),
  p("Address: H-1106, Purva Seasons, CV Raman Nagar, Bengaluru – 560093"),

  p("By using the Platform, you acknowledge that you have read, understood, and agreed to these Terms &amp; Conditions."),
].join("\n");
